export const PROMPT_WORD_LIMIT = 250;

export function countWords(value: string | null | undefined): number {
  const trimmed = (value || '').trim();
  if (!trimmed) return 0;
  return trimmed.split(/\s+/).length;
}

export function promptError(value: string | null | undefined): string {
  const count = countWords(value);
  if (!count) return 'Answer this prompt.';
  if (count > PROMPT_WORD_LIMIT) return `Use ${PROMPT_WORD_LIMIT} words or fewer.`;
  return '';
}
